import { Component, OnInit, inject, input, signal } from '@angular/core';

import { CasinoManager, ConfigProviderService, GlobalClientConfig } from '@casinocore/platform/core';
import {
    CsBadgeComponent,
    FavCtaComponent,
    FavIconKindType,
    FreeSpinsSummaryIconComponent,
    GradientNumberComponent,
    HyperLinkCtaComponent,
    ImageLoaderComponent,
    QuickInfoIconComponent,
    TileFooterComponent,
    TopTenGameTileAggregationComponent,
} from '@frontend/casino-ui';
import {
    JackpotRibbonComponent,
    JackpotValueEventHydratorDirective,
    JackpotValueIncrementalTickingDirective,
} from '@frontend/casino-ui/jackpot-ribbon';
import { DsButton } from '@frontend/ui/button';
import { DeviceService } from '@frontend/vanilla/core';

import { FavouriteConjugateDirective } from '../../modular-casino/directives/favourite.directive';
import { MoreInfoDirective } from '../../modular-casino/directives/moreinfo.directive';
import { GameModel, GameTileSettings, Top10GameTileModel } from '../../modular-casino/models/gametile.models';
import { JackpotRibbon } from '../../modular-casino/models/jackpot.models';
import { FeatureConfig } from '../../modular-casino/models/modular-config.models';
import { SubcategoryModel } from '../../modular-casino/models/modular-lmt-category.models';
import { JackpotRibbonRenderService } from '../../modular-casino/services/jackpot-ribbon-render.service';
import { ModularGameLaunchService } from '../../modular-casino/services/modular-gamelaunch.service';
import { LobbyType } from '../top-ten-games.model';

@Component({
    selector: 'cc-top-ten-game-tile',
    imports: [
        TopTenGameTileAggregationComponent,
        GradientNumberComponent,
        ImageLoaderComponent,
        CsBadgeComponent,
        FreeSpinsSummaryIconComponent,
        FavCtaComponent,
        QuickInfoIconComponent,
        HyperLinkCtaComponent,
        JackpotRibbonComponent,
        TileFooterComponent,
        JackpotValueEventHydratorDirective,
        JackpotValueIncrementalTickingDirective,
        DsButton,
        MoreInfoDirective,
        FavouriteConjugateDirective,
    ],
    templateUrl: './top-ten-game-tile.component.html',
})
export class TopTenGameTileComponent implements OnInit {
    topTenGame = input.required<Top10GameTileModel>();
    isLegacy = input.required<boolean>();
    lobbyType = input.required<LobbyType>();
    tileIndex = input.required<number>();
    subCategory = input.required<SubcategoryModel>();
    jackpotRibbonNewStyling: string;

    gameTileSettings: GameTileSettings;
    jackpotRibbonData: JackpotRibbon;
    stickerStyles: {
        LMS_CAPEXCLUSIVE: string;
        UkStickerStyle1: string;
        UkStickerStyle2: string;
    };
    isNewQuickInfoEnabled = signal(false);
    newQuickInfoStyle = signal(false);
    global: GlobalClientConfig;

    private readonly jackpotRibbonRenderService = inject(JackpotRibbonRenderService);
    private readonly modularGameLaunchService = inject(ModularGameLaunchService);
    private readonly deviceService = inject(DeviceService);
    private readonly configProviderService = inject(ConfigProviderService);
    private readonly casinoManager = inject(CasinoManager);

    ngOnInit(): void {
        this.updateGameTileSettings();
        this.getJackPotRibbonData();
        this.global = this.configProviderService.provideGlobalConfig();
        this.stickerStyles = this.global.stickerStyles;
        const features: FeatureConfig = this.configProviderService.provideFeaturesConfig();
        this.newQuickInfoStyle.set(this.casinoManager.IsFeatureEnabledforLobbytype(this.lobbyType(), features.newQuickInfoStyle));
        this.isNewQuickInfoEnabled.set(this.casinoManager.IsFeatureEnabledforLobbytype(this.lobbyType(), features.enableQuickInfoLobbyType));
        this.jackpotRibbonNewStyling = this.casinoManager.IsFeatureEnabledforLobbytype(this.lobbyType(), features.newJackpotRibbonStyling)
            ? 'left'
            : 'centered';
    }

    isMoreInfoEnabled(): boolean {
        return this.isNewQuickInfoEnabled() && this.newQuickInfoStyle();
    }

    getFavVariantKind(): FavIconKindType {
        return this.global.lobbyConfigurations.FavouriteHeart.toLowerCase() === 'true' ? FavIconKindType.Heart : FavIconKindType.Star;
    }

    onGameLaunch(game: GameModel | undefined): void {
        this.modularGameLaunchService.clickHandler(game, this.subCategory());
    }

    private updateGameTileSettings(): void {
        this.gameTileSettings = {
            gameLaunch: { ctaText: this.configProviderService.provideGlobalConfig().messages.UKPlayNow },
            moreInfo: { displayText: this.configProviderService.provideGlobalConfig().messages.UKMoreInfo },
            isTouch: this.deviceService.isTouch,
            icon: { gameTileBorderRadius: '' },
        };
    }

    private getJackPotRibbonData() {
        this.jackpotRibbonData = this.jackpotRibbonRenderService.getJackpoRibbonData(this.lobbyType());
    }
}
